import { Dispatch } from 'redux';
import { Condition } from '../reducers/nodesReducer';
import * as actions from './actionCatalog';
import defaultDebounce from './debouncer';
import * as http from '../http';

const regularGetConditions = (dispatch: Dispatch) => http.get<Condition>(actions.GET_CONDITIONS, dispatch);
const debouncedGetConditions = defaultDebounce(regularGetConditions);

export const getConditions = () => debouncedGetConditions;
export const forceGetConditions = () => regularGetConditions;

export function insertCondition(condition: Condition) {
  return http.post<void>(actions.CONDITIONS, condition);
}

export function updateCondition(condition: Condition) {
  return http.put<void>(actions.CONDITIONS, condition);
}

export function deleteCondition(pk: number) {
  return http.del<void>(actions.CONDITIONS, { pk });
}
